<template>
  <div class="bg-white border p-2 mt-3">
    <div class="table-responsive position-relative"
      :class="{ 'with-actions-gap': users.length < 4, 'opacity-50': loading }">
      <table class="table">
        <caption class="sr-only" data-no-export>{{ i18n('User List') }}</caption>
        <thead>
          <tr class="d-none d-lg-table-row">
            <th scope="col">{{ i18n('Id') }}</th>
            <th scope="col">{{ i18n('Username') }}</th>
            <th scope="col">{{ i18n('Type') }}</th>
            <th scope="col">{{ i18n('Name') }}</th>
            <th scope="col">{{ i18n('Email') }}</th>
            <th scope="col">{{ i18n('Company') }}</th>
            <th data-no-export scope="col" style="min-width: 48px">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <UserListItem v-for="user in users" :user="user" :key="user.id" @edit="showUserModal"
            @deleted="$emit('deleted', $event)" @updated="$emit('updated', $event)"
            @updating="$emit('updating', $event)" />
          <EmptyListItem v-if="!users || users.length == 0" :loading="loading" :colspan="7" />
          <LazyLoadListItem v-if="!loading && (lazyLoad || autoLazyLoad)" :autoLazyLoad="autoLazyLoad" :colspan="7"
            @next="$emit('next', $event)" />
        </tbody>
      </table>
      <div class="position-absolute h-100 w-100 top-0" @click.stop v-if="loading"></div>
    </div>
  </div>
  <UserModal ref="UserModal" @updated="$emit('updated', $event)" />
</template>

<script>
import UserListItem from "@/components/user/UserListItem.vue";
import UserModal from "@/components/user/UserModal.vue";
import EmptyListItem from "@/components/common/list/EmptyListItem.vue";
import LazyLoadListItem from "@/components/common/list/LazyLoadListItem.vue";
import Tooltip from "@/components/common/layout/Tooltip.vue";

export default {
  components: {
    UserListItem,
    UserModal,
    EmptyListItem,
    LazyLoadListItem,
    Tooltip,
  },
  emits: [
    'updated',
    'deleted',
    'updated',
    'updating',
    'next',
  ],
  props: {
    loading: Boolean,
    lazyLoad: Boolean,
    autoLazyLoad: Boolean,
    users: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  methods: {
    showUserModal(user) {
      if (!this.$refs.UserModal) return;
      this.$refs.UserModal.show(user.id);
    },
  },
};
</script>